/*export const BASE_URL = 'https://94e9eqfuwl.execute-api.us-east-2.amazonaws.com/dev/';*/
export const CONTACT_US_EMAIL = 'support@root-nyc.com';
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const STRIPE_KEYS = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

export const sprintStatus = [
  {
    name: 'Draft',
    value: 'Draft',
  },
  {
    name: 'In Review',
    value: 'In Review',
  },
  {
    name: 'Submit Stories',
    value: 'Submit Stories',
  },
  {
    name: 'In Progress',
    value: 'In Progress',
  },
  {
    name: 'Completed',
    value: 'Completed',
  },
  {
    name: 'Cancelled',
    value: 'Cancelled',
  },
];
export const sprintReviewStatus = [
  {
    name: 'N/A',
    value: 'N/A',
  },
  {
    name: 'User Story Review',
    value: 'User Story Review',
  },
  {
    name: 'In Review',
    value: 'In Review',
  },
  {
    name: 'Code Review',
    value: 'Code Review',
  },
  {
    name: 'Completed',
    value: 'Completed',
  },
];
export const complexity = [
  {
    name: 'Low',
    value: 'Low',
  },
  {
    name: 'Medium',
    value: 'Medium',
  },
  {
    name: 'High',
    value: 'High',
  },
];
export const developmentStatus = [
  {
    name: 'Not Started',
    value: 'Not Started',
  },
  {
    name: 'In Progress',
    value: 'In Progress',
  },
  {
    name: 'Completed',
    value: 'Completed',
  },
];
export const acceptanceStatus = [
  {
    name: 'N/A',
    value: 'N/A',
  },
  {
    name: 'Test',
    value: 'Test',
  },
  {
    name: 'Bug Fix',
    value: 'Bug Fix',
  },
  {
    name: 'Accepted',
    value: 'Accepted',
  },
  {
    name: 'Not Started',
    value: 'Not Started',
  },
];
//Success Message On API Call
export const PROJECT_SAVE_SUCCESS_MSG = 'Project saved successfully';
export const PROJECT_UPDATE_SUCCESS_MSG = 'Project update successfully';
export const SPRINT_UPDATE_SUCCESS_MSG = 'Sprint update successfully';
export const SPRINT_SAVE_SUCCESS_MSG = 'Sprint saved successfully';
export const USER_STORIES_SAVE_SUCCESS_MSG = 'User stories saved successfully';
export const LOGOUT_SUCCESS_MSG = 'User Logout Successfully';
export const USER_UPDATE_SUCCESS_MSE = 'User Update Successfully';
export const USER_DELETE_SUCCESS_MSE = 'User delete Successfully';
export const CREATE_USER_SAVE_SUCCESS_MSG = 'User create Successfully';
export const ADD_DISCOUNT_MENAGEMENT_MSG = 'Add discount Successfully';
export const DELETE_DISCOUNT_MENAGEMENT_MSG =
  'Discount coupons delete Successfully';
export const USER_STORY_MOVE_MSG = 'User story move Successfully';
export const UPDATE_USER_STORIES_SAVE_SUCCESS_MSG =
  'User story update successfully';
export const APPLY_VOUCHER_MSG = 'Voucher apply successfully';
export const DELETE_USER_STORY_MSG = 'User story delete successfully';
export const PAYMENT_MSG = 'Your Payment is successfully';
export const UNSELECTED_STORIES_SUBMISSION_ERROR_MSG =
  'Any user stories that have not been selected, needs to be moved to another sprint before submission';
export const NOT_ENOUGH_CREDITS_ERROR_MSG =
  "You don't have enough credits to proceed with selected user stories, please add more credits";
